import COLORS from "../Helpers/utils";

export enum BuildingType {
    standard = "standard",
    complement = "complement",
    toiletArchipelago = "toilet_archipelago",
    toiletReserve = "toilet_reserve",
    other = "other",
}

export function colorForBuildingType(type?: BuildingType): string {
    switch (type) {
        case BuildingType.standard: default:
            return COLORS.primaryDark;
        case BuildingType.complement:
            return COLORS.deepGreen;
        case  BuildingType.other:
            return COLORS.gold;
    }
}
